import "./App.css";
import { useLocation, useRoutes } from "react-router-dom";
import { routes } from "./routes/route";
import React, { useEffect, useState } from "react";
import { enhancePerformance } from "./helpers/utils";
import "yet-another-react-lightbox/styles.css";
import { useShowManualData } from "./helpers/SwitchTab_Context";
import { useDispatch, useSelector } from "react-redux";
import {
  checkParichayAuthenticityApi,
  checkParichayToken,
} from "./services/api";
import Session_Expired from "./common/Session_Expired";
import Common_Logout from "./common/Common_Logout";
import InactivityTimeout from "./component/Dashboard/Inactivity_Timeout";
import { resetSiteData } from "./redux/slices/dashData.slices";

function App() {
  const routing = useRoutes(routes);
  const dispatch = useDispatch();
  const { checkAuthenticity } = useShowManualData();
  const location = useLocation();
  const token = localStorage.getItem(`nic_front_authToken`);
  const { logout } = Common_Logout();
  const isAuthentic = useSelector(
    (state) => state?.checkAuthentication?.data?.status
  );
  const isParichayAuthentic = useSelector(
    (state) => state?.parichayCheckToken?.data?.error
  );

  const [sessionOut, setSessionOut] = useState(false);
  const userSite = useSelector((state) => state?.switchSiteData?.data?.data);
  const isParichayAuthenticated = localStorage.getItem(`parichay_login`)
    ? true
    : undefined;

  useEffect(() => {
    checkToken();
  }, [location.pathname]);

  useEffect(() => {
    // enhancePerformance();
    checkToken();
    checkMode();
  }, []);

  const checkToken = React.useCallback(() => {
    if (token) {
      checkAuthenticity();
    }
    if (token && isParichayAuthenticated) {
      checkParichayAuthenticityApi();
    }
  }, [
    token,
    isParichayAuthenticated,
    checkAuthenticity,
    checkParichayAuthenticityApi,
  ]);

  const checkMode = React.useCallback(() => {
    const getMode = localStorage.getItem("dark-mode");
    if (!getMode) window.document.body.classList.remove("dark-mode");
    else window.document.body.classList.add("dark-mode");
  }, []);

  React.useEffect(() => {
    if (token) {
      if (isAuthentic === false) {
        logout();
      }
    }
  }, [isAuthentic, isParichayAuthentic]);

  console.log("userSite#$%^&*()", userSite);

  return (
    <>
      <InactivityTimeout />
      {routing}
    </>
  );
}

export default App;
